import React, { Component } from "react";
import {
    Modal,
    ModalHeader,
    ModalBody,
    Button,
    Row,
    Col,
    Input,
    Label
} from "reactstrap";
import Geosuggest from "react-geosuggest";

import ConfirmationModal from "../../ConfirmationModal";
import TYItem from "../../TYItem";

import BusinessAddress from "../../../models/business/address";
import Registry from "../../../Utils/Registry";
import {NotificationManager} from "react-notifications";


class EnterpriseInformationDeliveryListItem extends Component{
    constructor(props){
        super(props);

        this.toggle = this.toggle.bind(this);
        this.toggleUpdate = this.toggleUpdate.bind(this);
        this.toggleConfirmation = this.toggleConfirmation.bind(this);
        this.handleInputUpdate = this.handleInputUpdate.bind(this);
        this.addressChoosen = this.addressChoosen.bind(this);
        this.postUpdate = this.postUpdate.bind(this);
        this.removeItem = this.removeItem.bind(this);

        this.address = this.props.address;

        this.state = {
            address_field: this.address.location,
            address_name: this.address.name,
            updateOpen: false,
            dropdownOpen: false,
            confirmationOpen: false,
            valid_address: false
        };

        this.api = Registry.registered("api");
    }

    toggle(){
        this.setState({dropdownOpen: !this.state.dropdownOpen});
    }

    toggleUpdate(){
        this.setState({updateOpen: !this.state.updateOpen});
    }

    toggleConfirmation(){
        this.setState({confirmationOpen: !this.state.confirmationOpen});
    }

    removeItem(){
        this.setState({confirmationOpen: false});
        this.address.del(this.props.onAddressRemoved);
    }

    postUpdate(){
        if (this.state.valid_address) {
            this.toggleUpdate();

            this.address.location = this.state.address_field;
            this.address.name = this.state.address_name;

            if(this.address.isLoaded())
                this.address.save(this.props.onAddressUpdated);
        }
    }

    handleInputUpdate(e, key){
        let s = this.state;
        if(s.hasOwnProperty(key))
            s[key] = e.target.value;
        this.setState(s);
    }

    addressChoosen(address){
        this.setState({
            address_field: address.description
        }, () => {this.checkAddress()});
    }

    checkAddress = () => {
        this.api.get("/orders/checkZone?address=" + this.state.address_field + "&is_business=1")
            .then(() => {
                this.setState({valid_address: true});
            })
            .catch(() => {
                NotificationManager.error("Cette adresse n'est pas dans la zone de livraison");
                this.setState({valid_address: false});
            })
    };

    render(){
        return <div className="ty-list-item">
            <TYItem
                icon="icon icon-map-marker-radius"
                actions={[
                    { label: "Modifier", onclick: this.toggleUpdate},
                    { label: "Supprimer", onclick: this.toggleConfirmation}
                ]}
            >
                { this.address.getLabel() }
            </TYItem>

            <Modal isOpen={this.state.updateOpen} toggle={this.toggleUpdate}>
                <ModalHeader toggle={this.toggleUpdate}>Modifier l'adresse de livraison</ModalHeader>
                <ModalBody>
                    <Row>
                        <Col md="12">
                            <Label>Adresse de livraison</Label>
                            <Geosuggest
                                country="fr"
                                onSuggestSelect={this.addressChoosen}
                                placeholder="Ex: 7 rue de Paris, 75001 ..."
                                initialValue={this.state.address_field}
                            />
                        </Col>
                    </Row>
                    <Row className="marg-t-15 marg-b-15">
                        <Col>
                            <Label>Designation</Label>
                            <Input type="text" placeholder="Exemple: Bureaux" className="wp-100" value={this.state.address_name} onChange={e => {this.handleInputUpdate(e, "address_name")}} required />
                        </Col>
                    </Row>

                    <Row className="marg-t-20">
                        <Col md="12" className="center">
                            <Button color="primary" className="text-uppercase" onClick={this.postUpdate}>Sauvegarder</Button>
                        </Col>
                    </Row>
                </ModalBody>
            </Modal>

            <ConfirmationModal
                isOpen={this.state.confirmationOpen}
                toggle={this.toggleConfirmation}
                validate={this.removeItem}
                refuse={this.toggleConfirmation}
                title="Supprimer l'adresse de livraison"
                content={<div>
                    Etes-vous sûr de vouloir supprimer cette adresse :<br />
                    <span className="bold">{ this.address.getLabel() }</span> ?
                </div>}
            />
        </div>;
    }
}

EnterpriseInformationDeliveryListItem.defaultProps = {
    address: new BusinessAddress(),
    onAddressRemoved: () => {},
    onAddressUpdated: () => {}
};

export default EnterpriseInformationDeliveryListItem;



// WEBPACK FOOTER //
// ./src/components/Enterprise/Information/DeliveryItem.js